type PendingListener = () => void;

let pendingPrefix: string | null = null;
const listeners = new Set<PendingListener>();

const setPendingChord = (prefix: string | null): void => {
	if (pendingPrefix === prefix) return;
	pendingPrefix = prefix;
	for (const listener of listeners) listener();
};

const subscribePendingChord = (listener: PendingListener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

const getPendingChord = (): string | null => pendingPrefix;

const chordPendingStore = {
	get: getPendingChord,
	set: setPendingChord,
	subscribe: subscribePendingChord
};

export default chordPendingStore;
